import { httpClient } from '@/services/http/httpClient'

import type { User } from '../types'

export async function searchUsersForMention({
  query,
}: {
  query: { search: string }
}) {
  const { data } = await httpClient.get<User[]>(
    `/users/for-mention?search=${query.search}`,
  )
  return data
}
